var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTv = function SvgTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6V16H21V6H3ZM7.2585 18C7.26175 18.0964 7.251 18.1949 7.22474 18.2929L6.70711 20.2247C6.56416 20.7582 6.01583 21.0748 5.48236 20.9319C4.9489 20.7889 4.63231 20.2406 4.77526 19.7071L5.23267 18H3C1.89543 18 1 17.1046 1 16V6C1 4.89543 1.89543 4 3 4H21C22.1046 4 23 4.89543 23 6V16C23 17.1046 22.1046 18 21 18H18.7673L19.2247 19.7071C19.3677 20.2406 19.0511 20.7889 18.5176 20.9319C17.9842 21.0748 17.4358 20.7582 17.2929 20.2247L16.7753 18.2929C16.749 18.1949 16.7382 18.0964 16.7415 18H7.2585Z",
    fill: "currentColor"
  })));
};
export default SvgTv;